export const footer = {
  footerTitleGame: "最好的游戏",
  footerTitleGameCasino: "赌场",
  footerTitleGameLottery: "彩票",
  footerTitleGameGames: "游戏",
  footerTitleSports: "体育",
  footerTitleGameSlots: "老虎机",
  footerTitleGameMinigame: "迷你游戏",
  footerTitleNews: "新闻",
  footerTitleLiga: "联赛",
  footerTitleLigaEsports: "电子竞技",
  footerTitleLigaLeague: "联赛",
  footerTitleLigaFootball: "欧洲联赛",
  footerTitleSupport: "支持",
  footerTitleHelp: "帮助中心",
  footerTitleTerms: "条款和条件",
  footerTitleSocial: "关注我们",
  footerTitleApp: "下载我们的App",
  footerTitlePromotions: "促销",
  footerTitleResponsibleGambling: "负责任地游戏。仅限18岁以上。",
  footerTitleSafeGame: "为了更安全的游戏",
  footerInfoTitle: "信息",
  footerCategoriesTitle: "类别",
  footerContactSupport: "联系支持",
  footerSupportDesc: "如有问题请联系我们",
  footerPromoTitle: "免费旋转！",
  footerPromoDesc: "首次存款每存40玻利瓦尔可获一次免费旋转",
  footerPromoAvailable: "适用于Android和iOS",
  footerWinAppTitle: "下载Windows应用，在电脑上畅玩",
  footerInstallBtn: "安装",
  footerRegisterBtn: "注册",
  footerGPlayTitle: "在 Google Play 下载",
  footerGPlayDesc: "在您的安卓设备上获得最佳游戏体验",
  footerIOSTitle: "在 App Store 下载",
  footerIOSDesc: "适用于 iPhone 和 iPad",
  footerDownloadBtn: "下载",
  footerGetItOn: "下载于",
  footerDownloadOn: "下载到",
};
